import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Heart, Building2, KeyRound } from "lucide-react";
import { COMPANY } from "../lib/config";
import { getFavorites } from "../lib/favorites";

const links = [
  { to: "/", label: "Ana Sayfa" },
  { to: "/ilanlar?islem=satilik", label: "Satılık" },
  { to: "/ilanlar?islem=kiralik", label: "Kiralık" },
  { to: "/hakkimizda", label: "Hakkımızda" },
  { to: "/iletisim", label: "İletişim" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [favCount, setFavCount] = useState(0);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const upd = () => setFavCount(getFavorites().length);
    upd();
    window.addEventListener("favorites-changed", upd);
    const os = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", os);
    return () => { window.removeEventListener("favorites-changed", upd); window.removeEventListener("scroll", os); };
  }, []);

  return (
    <header data-testid="navbar" className={`fixed top-0 inset-x-0 z-40 transition-colors duration-300 ${scrolled ? "backdrop-blur-xl bg-white/85 border-b border-slate-200/80" : "bg-white/60 backdrop-blur-md"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
            <div className="w-10 h-10 rounded-lg bg-slate-900 flex items-center justify-center">
              <Building2 className="w-5 h-5 text-white" strokeWidth={1.6} />
            </div>
            <div className="leading-tight">
              <div className="font-display text-lg text-slate-900">SANTRAL EMLAK</div>
              <div className="text-[10px] tracking-[0.28em] uppercase text-slate-500">LTD · Est. 1995</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-10">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) => `text-sm font-medium tracking-wide transition-colors ${isActive ? "text-[#C0562F]" : "text-slate-700 hover:text-slate-900"}`}
                data-testid={`nav-link-${l.label}`}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link to="/favorilerim" data-testid="nav-favorites" className="relative w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center hover:border-[#C0562F] transition-colors">
              <Heart className="w-4 h-4 text-slate-700" />
              {favCount > 0 && (
                <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#C0562F] text-white text-[10px] font-bold flex items-center justify-center">{favCount}</span>
              )}
            </Link>
            <button
              onClick={() => navigate("/ilanlar")}
              data-testid="nav-cta-browse"
              className="hidden md:inline-flex btn-primary px-5 py-2.5 rounded-full text-sm font-semibold"
            >
              İlanları İncele
            </button>
            <Link
              to="/admin/giris"
              data-testid="nav-admin-key"
              aria-label="Yönetici Girişi"
              title="Yönetici Girişi"
              className="group relative w-10 h-10 rounded-full bg-slate-900 hover:bg-[#C0562F] text-white flex items-center justify-center transition-all duration-300 hover:rotate-[-12deg] shadow-[0_8px_20px_-8px_rgba(15,23,42,.5)]"
            >
              <KeyRound className="w-4 h-4" strokeWidth={2} />
              <span className="pointer-events-none absolute -bottom-9 right-0 whitespace-nowrap px-2.5 py-1 rounded-md bg-slate-900 text-white text-[10px] tracking-widest uppercase font-semibold opacity-0 group-hover:opacity-100 transition-opacity">Yönetici Girişi</span>
            </Link>
            <button
              className="lg:hidden w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center"
              onClick={() => setOpen((v) => !v)}
              aria-label="Menü"
              data-testid="nav-menu-toggle"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white/95 backdrop-blur-xl">
          <div className="px-4 py-4 space-y-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) => `block px-4 py-3 rounded-lg text-sm font-medium ${isActive ? "bg-slate-100 text-[#C0562F]" : "text-slate-700 hover:bg-slate-50"}`}
                data-testid={`nav-mobile-${l.label}`}
              >
                {l.label}
              </NavLink>
            ))}
            <button
              onClick={() => { setOpen(false); navigate("/ilanlar"); }}
              className="w-full btn-primary px-5 py-3 rounded-full text-sm font-semibold mt-2"
              data-testid="nav-mobile-cta"
            >İlanları İncele</button>
          </div>
        </div>
      )}
    </header>
  );
};
